import { render, staticRenderFns } from "./create_trivia_component.vue?vue&type=template&id=32b0283d&scoped=true"
import script from "./create_trivia_component.vue?vue&type=script&lang=js"
export * from "./create_trivia_component.vue?vue&type=script&lang=js"
import style0 from "./create_trivia_component.vue?vue&type=style&index=0&id=32b0283d&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32b0283d",
  null
  
)

export default component.exports